/* tslint:disable */
/* eslint-disable */
/**
 * Public REVER API
 * The public REVER API allows you to manage your e-commerce returns and integrate your sites.  * Integrate the returns portal in your site * Programmatically create returns * Retrieve returns information * Action the returns from your apps (accept, reject) * Edit returns data  You can download the openapi file in [here](https://api.byrever.com/v1/docs/openapi.yaml) and use it to generate your client code.  ## E-commerce IDs and groups Most of the times, you will just have to use the e-commerce ID given at onboarding time.  However, in case you want to manage multiple e-commerces at the same time, a group id is needed. An e-commerce group is just a name that identifies a group of e-commerces that are managed together. Typically, these are different brands belonging to the same group.  ## Branding and configuration At this moment, settings and configuration are read-only.  They can only be changed upon request to your account manager.  We are planning to release a set of methods to allow self-configuration very soon!  ## Authentication This API has public and private methods. The private methods must use one of the following authentication methods:  * API Key * OAuth  ### Authenticating via API key This authentication method is normally used for Server to Server (unattended) scenarios. You must request the API key via your account manager. **You must keep the API key secret**, do not share it with anybody.  To authenticate a request using an api key, use the header **x-rever-api-key**. Example: `x-rever-api-key: 87bf223499abeef`  ### Authenticating via OAuth token This authentication method is normally used for User to Server scenarios. You must request the creation of a user via your account manager.  To authenticate a request using an OAuth token:  * Obtain a token at `https://rever-dashboard.eu.auth0.com/oauth/token`. Please follow [these instructions](https://auth0.com/docs/secure/tokens/access-tokens/get-access-tokens). * `Authentication: Bearer <token obtained>`  ## Integration with REVER REVER has [out-of-the-box integrations with the most popular e-commerce](https://itsrever.com/) platforms. However, if you want to integrate REVER with your own e-commerce, you can do it in two ways:  * Implementing yourself the API as described below in `Implementing your own integration` * Requesting a custom integration to your account manager  You can download the openapi file just with the integration methods in [here](https://api.byrever.com/v1/docs/openapi_integration.yaml) and use it to generate your stubs and tests.  Please forward any issue, question or typo to developer@itsrever.com  ## Linking to the returns portal The Returns Portal is the REVER application that shoppers use to start and manage their return processes. Typically, shoppers have to introduce some data from the order they want to return, like the order number and the e-mail used. If you want to link directly to a specific return process for a specific order from your platform, use the following URL structure:  ``` https://returns.itsrever.com/<slug>?orderNumber=<order_number>&email=<customer_email> ```  Parameters:  - **slug**: Represents your unique e-commerce identifier. - **orderNumber**: The order number associated with the return. - **email**: The email of the customer initiating the return.  Here is an example for the slug `XYZ`:  `https://returns.itsrever.com/XYZ?orderNumber=%23REVER123&email=demo@itsrever.com`  Make sure to replace `slug`, `orderNumber`, and `email` with appropriate values for each use case.  Remember to URL-encode special characters like #.  ## Implementing your own integration Integrating with REVER is very simple. You just need to implement the API methods described in the [integration section](#public-rever-api-integration). Depending on the REVER features you want to use, you will need to implement some or all of the methods.  List of features:  * Instant Refund: Ability to refund the customer instantly, directly from REVER * Gift Card: Ability to refund the customer with a gift cad * Promo Code: Ability to refund the customer with a promo code instead of a gift card * Original Payment Method (OPM): Ability to refund the customer with the original payment method * Exchange order: Ability to create an exchange order as a refund method. Requires products with variants * Non returnable items (NRI): Ability to mark some items or orders as non returnable. Requires that the order brings tagging information.  Table of requirements per feature:  |     Method                                   | Instant Refund | Gift Card | Promo Code | OPM | Exchange order |  | -------------------------------------------- | -------------- | --------- | ---------- | --- | -------------- | | [GET order](#findorderbycustomerprintedorderid)   | X              | X         | X          |  X  | X              | | [POST note](#addnotetoorder)                 | X              | X         | X          |  X  | X              | | [POST return](#createreturn)                 | X              | X         | X          |  X  | X              | | [PUT return](#updatereturn)                  | X              | X         | X          |  X  | X              | | PUT gift                                     |                | X         |            |     |                | | DELETE gift                                  |                | X         |            |     |                | | POST promo                                   |                |           | X          |     |                | | DELETE promo                                 |                |           | X          |     |                | | PUT order                                    |                |           |            |     | X              | | GET shipping                                 |                |           |            |     | X              | | [POST refund] (#createrefund)                |                |           |            |  X  |                |  ### URLs and authentication The methods can be implemented at any url. However, the HTTP verb is mandatory.  For each endpoint, we expect a request pattern.  For example, the `GET order` method could be implemented as `GET yourdomain.com/api/rever/{order_id}`.  The `{order_id}` is a placeholder for the order id. The `{order_id}` is mandatory, but the rest of the url is up to you.  At this moment, we only support the following authentication methods:  - **API key authentication** In each request, we will provide the API key you set up for REVER in the given header, for example `x-rever-api-key`. - **OAuth 2.0 (two legged)** Before each request, we will request a token in the provided auth server using the provided `client_id` and `client_secret`.  ### Developing and testing your integration To facilitate the integration, we provide a [public repository](https://github.com/itsrever/integration) with a sample implementation of the API and the testing framework for any language.  Thanks to this Docker image, you can test your integration at any point without connecting with REVER. Just execute the following command:  ``` docker run -it --rm      --name rever-integration-tester \\     --key=[API_KEY] \\     --order=https://yourdomain.com/api/rever/{order_id} \\     --product=https://yourdomain.com/api/rever/product/{product_id} \\     ... ``` The output of that command describes which test scenarios passed or not.  Please check the [README](https://github.com/itsrever/integration) to check how to setup the OAuth 2.0 authentication.  ### Submitting your integration Once you have implemented the methods you need, and verified that all of the testing scenarios pass, you can submit your integration to REVER. Just send an email to `developer@itsrever.com` with the information below and we will add your integration to the system.  - Your data     - Company     - Contact information (important, for notifications) - Features supported - Methods implemented     - Production URL pattern for each - Output of the testing framework - If using API Key: Auth header name + API key to be used in production through onetimesecret.com (or similar) - If using OAuth: Auth server URL + Client ID + Client Secret through onetimesecret.com (or similar)  ### Integration disclaimer  * REVER is not responsible for any issues that may arise from the integration of the API.  * At the moment that any bug is discovered by any of the parties, it should be shared as soon as possible. * REVER might request rotating the API key if it is considered that the key has been compromised. * New features might require the implementation of new methods or the amendment of existing ones. * Submitting the integration does not guarantee that it will be approved. REVER reserves the right to reject any integration. * REVER reserves the right to remove any integration at any time. * REVER reserves the right to change the API at any time. * REVER reserves the right to change the testing scenarios at any time. * REVER reserves the right to change the testing framework at any time.  ## Rate limiting The API is rate limited. If you receive a 429 error, please wait a few seconds and retry.  ## CORS policy At the moment, only the requests coming from browsers in the address https://dashboard.byrever.com or https://returns.itsrever.com are allowed.  If you require to use a custom domain, please contact your account manager. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "https://api.byrever.com".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
    url: string;
    options: RawAxiosRequestConfig;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}

interface ServerMap {
    [key: string]: {
        url: string,
        description: string,
    }[];
}

/**
 *
 * @export
 */
export const operationServerMap: ServerMap = {
    "AIInsightsApi.getAIInsights": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "AIInsightsApi.postAIInsightsFeedback": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "AppStoreIntegrationsApi.getIntegrationDetails": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "AppStoreIntegrationsApi.getIntegrationsStatus": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "AppStoreIntegrationsApi.listAvailableIntegrations": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "AppStoreIntegrationsApi.saveIntegrationCredentials": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "BillingApi.getInvoiceFileURL": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "BillingApi.getInvoicedEcommerces": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "BillingApi.getInvoices": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "BillingApi.getInvoicingPortalURL": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ChatApi.chat": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV1DirectStubApi.storeCreateOrder": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV1DirectStubApi.storeCreatePromocode": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV1DirectStubApi.storeCreateReturn": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV1DirectStubApi.storeFindOrder": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV2StubApi.cancelExchangeOrder": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV2StubApi.cancelGiftCard": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV2StubApi.cancelPromocode": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV2StubApi.createExchangeOrder": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV2StubApi.createGiftCard": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV2StubApi.createPromocode": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV2StubApi.getGiftCard": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV2StubApi.getMenu": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV2StubApi.getOrderById": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV2StubApi.getOrderByNumber": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV2StubApi.getOrderTransactions": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV2StubApi.getProduct": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV2StubApi.getPromocode": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "CustomIntegrationV2StubApi.listProducts": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.countryReturnRate": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.findProducts": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.getAvailableFilters": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.getItemsAndTotalsPerDay": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.getScopePortals": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.getUpsell": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.periodReturnRate": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.problematicProducts": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.productDetailView": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.productMainView": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.returnRateByProduct": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.returnRateByProductCountry": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.returnRateByProductInStoreLevel": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.returnRateTable": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.returnsByCountry": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.returnsByCountryAndProduct": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "DashboardAnalyticsApi.returnsMainView": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.confirmPrestashopShop": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.confirmShop": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.deactivatePrestashopShop": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.findCustomPlatformSettings": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.findCustomSettingsFromShopID": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.findSalesforceSettings": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.getAvailableRestockLocations": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.getProductsAndBrandsFromTheBradery": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.linkPrestashopShop": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.listStores": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.magentoIdentityLink": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.magentoOauth1Callback": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.markAsRefundedPublic": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.registerPrestashopShop": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.registerShop": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.searchCatalog": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.shopLifecycleWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.shopifyAppInstall": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ECommerceApi.shopifyOAuthCallback": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "EventsApi.amphoraReturnWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "EventsApi.asyncRefundConfirmationWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "EventsApi.easypostTrackerWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "EventsApi.flexportReturnWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "EventsApi.picqerReturnWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "EventsApi.seelWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "EventsApi.sendcloudParcelStatusWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "EventsApi.sevicaReviewWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "EventsApi.shopifyWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "EventsApi.typeformWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "EventsApi.way2SendReturnWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "EventsApi.zendeskWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "InditexReturnsServiceApi.calculateRefundMethods": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "InditexReturnsServiceApi.deriveAllocatedTimingId": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "InditexReturnsServiceApi.processReturn": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "InditexServiceApi.generateFileUploadURL": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "IntegrationApi.addNoteToOrder": [
        {
            url: "http://envoy.prd-rever.local:8080",
            description: "Endpoint used for internal methods. Not accessible from outside REVER infrastructure. Requires VPN or SSH tunnel.",
        }
    ],
    "IntegrationApi.createRefund": [
        {
            url: "http://envoy.prd-rever.local:8080",
            description: "Endpoint used for internal methods. Not accessible from outside REVER infrastructure. Requires VPN or SSH tunnel.",
        }
    ],
    "IntegrationApi.createReturn": [
        {
            url: "http://envoy.prd-rever.local:8080",
            description: "Endpoint used for internal methods. Not accessible from outside REVER infrastructure. Requires VPN or SSH tunnel.",
        }
    ],
    "IntegrationApi.findOrderByCustomerPrintedOrderId": [
        {
            url: "http://envoy.prd-rever.local:8080",
            description: "Endpoint used for internal methods. Not accessible from outside REVER infrastructure. Requires VPN or SSH tunnel.",
        }
    ],
    "IntegrationApi.updateReturn": [
        {
            url: "http://envoy.prd-rever.local:8080",
            description: "Endpoint used for internal methods. Not accessible from outside REVER infrastructure. Requires VPN or SSH tunnel.",
        }
    ],
    "InvoicingApi.getEcommerceInvoicingInfo": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "InvoicingApi.getEcommerceInvoicingInfoByStripeCustomer": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "InvoicingApi.getInvoicingCopies": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "InvoicingApi.postInvoicingTransaction": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "LogisticsApi.createOrderV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "LogisticsApi.createPickup": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "LogisticsApi.getLogisticOrderById": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "LogisticsApi.getPresignedURLLabel": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "LogisticsApi.getPublicProcessInfo": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "LogisticsApi.isPickupAvailable": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "LogisticsApi.saveManuallyCreatedLogisticOrder": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "MessagingApi.verifyWhatsAppWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "MessagingApi.whatsAppWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.addTheBraderyBrandTag": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.cancel": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.createTheBraderyBrand": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.listTheBraderyBrands": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.logistics": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.markAsRefundedExternally": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.redirectToContactForm": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.removeTheBraderyBrandTag": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.restockItems": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.reviewItemByOrderSKU": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.reviewItems": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.reviewItemsGeneric": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.submitAuthorization": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.transitionLKSS": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.updateLKSS": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "OpsApi.updateTheBraderyBrandEmail": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.addAdjustment": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.addComment": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.addReview": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.addTransactions": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.approveAll": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.changeCompensationMethod": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.changeToBankTransfer": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.createIncidentDocumentUploads": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.exportReturnProcesses": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.exportReturnProcessesCsv": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.findLineItemReturnReasons": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.findProcessCarriers": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.findProcessCountries": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.findProcessWarehouses": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.findProcesses": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.get": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.getAuthorizationStatus": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.getCancelExchangePreview": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.getHelpDeskProcessesByEmailAndEcommerceGroup": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.getLogisticSummaries": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.getLogisticsSummary": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.getReturnDocuments": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.getReturnSummaries": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.getReturnSummary": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.getReturnSummaryByPlatform": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.getReviews": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.getTransactions": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.getWfpClaimByReturnProcessID": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.listWithdrawalRequests": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.patchReturnProcess": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.rateLimitTest": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.requestCustomerUploadPhotos": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.setStoreAddress": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.setWithdrawalRequestClosed": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.updateLogistics": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.updateWorkflowStatus": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.uploadReturnDocuments": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProcessesApi.validateReview": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ProductRecommenderApi.getRecommendations": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReferralsApi.getReferralsByGroup": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReferralsApi.postReferral": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReportsServiceApi.generalReport": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "RestockApi.getRestockExternal": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.availableRefundMethodChangeOptions": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.calculateUpdateAmount": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.cancelReturnProcess": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.cancelWfpContract": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.createLiteOrder": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.deliveryNotePresignedURL": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.exchangeOptions": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.exchangeTimings": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.getOrder": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.importReturn": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.instructionsPresignedURL": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.labelPresignedURL": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.productDetails": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.requestNewLabel": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.stripeLiveWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.stripeTestWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.submitWithdrawal": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.trackingInfo": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "ReturnsApi.updateReturnProcess": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.addNewPASetting": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.addPASettingsSection": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.assignNangoPlatformConnection": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.checkNangoConnection": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.createAPIKey": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.createNangoConnectSession": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.createNangoReconnectSession": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.createUser": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.deleteCarrierConnection": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.deleteExchangesSettingsOverridesV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.deleteNangoConnection": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.deletePartnerConnection": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.deleteRDVSurplusOverrideV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.deleteRefundConfigurationOverrideV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.deleteReturnProcessConditionsOverrideV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.deleteReturnReasonsOverrideV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.deleteWarehouseConfigOverrideV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.deleteWarehousesV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findBranding": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findBrandingPublic": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findCredentials": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findEcommerce": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findEcommerceContacts": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findExchangeConditions": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findExchangeOrder": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findGroupContacts": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findInStoreSettings": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findItemReturnReasons": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findItemReturnReasonsByBody": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findLogisticSetting": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findPortalSettings": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findRefundConfiguration": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findReturnProcessConditions": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findShopifyAppAutomationToken": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findUsers": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findWarehouse": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findWarehousesByEcommerce": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findWarehousesByGroupV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findWithdrawalSettings": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.findWorkflowConfigurations": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.generateWebhookSigningSecret": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getAPIKeyValue": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getAllReturnReasons": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getDynamicWarehouse": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getECommerceSettings": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getECommerceSettingsDeprecated": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getECommerceTextCopies": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getECommerceTextCopiesV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getECommerceTextCopiesV3": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getEcommerceExchangesSettingsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getEcommercePASettings": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getEcommerceRDVSurplusV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getEcommerceRefundConfigurationV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getEcommerceReturnProcessConditionsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getEcommerceReturnReasonsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getEcommerceSettingsByGroup": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getEcommerceSettingsByGroupDeprecated": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getEcommerceWarehouseConfigsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getFlattenedPASettings": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getGroupExchangesSettingsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getGroupRDVSurplusV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getGroupRefundConfigurationV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getGroupReturnProcessConditionsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getGroupReturnReasonsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getGroupWarehouseConfigsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getReturnAmount": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getReturnAmountAvailable": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getRiskExposureSettings": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getWarehouseConfigsPublic": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getWebhookSigningSecret": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.getWebhookSubscriptions": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.linkNangoConnection": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.listAPIKeyGroups": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.listAPIKeys": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.listCarrierConnections": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.listGroupNangoConnections": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.listNangoConnections": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.listPartnerConnections": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.listWebhookSigningSecrets": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.me": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.onboard": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.patchBranding": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.patchReturnProcessConditions": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.postReturnAmount": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.publicReturnAmountAvailable": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.revokeAPIKey": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.revokeWebhookSigningSecret": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveBranding": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveCarrierConnection": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveCredentials": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveEcommerce": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveEcommerceContacts": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveEcommerceExchangesSettingsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveEcommerceRDVSurplusV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveEcommerceRefundConfigurationV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveEcommerceReturnProcessConditionsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveEcommerceReturnReasonsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveEcommerceWarehouseConfigsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveExchangeConditions": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveExchangeOrder": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveGroupContacts": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveGroupExchangesSettingsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveGroupRDVSurplusV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveGroupRefundConfigurationV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveGroupReturnProcessConditionsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveGroupReturnReasonsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveGroupWarehouseConfigsV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveInStoreSettings": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveLogisticSetting": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.savePartnerConnection": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveRefundConfiguration": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveReturnProcessConditions": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveReturnReasons": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveRiskExposureSettings": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveShopifyAppAutomationToken": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveWarehouseConfigsPublic": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveWarehouses": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveWarehousesV2": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.saveWorkflowConfigurations": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.sendTestWebhook": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.setUserBlocked": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.setWithdrawalSettings": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.unlinkNangoConnection": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.updateCopies": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.updateUser": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.uploadBrandingImage": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.upsertEcommercePASettings": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SettingsApi.upsertWebhookSubscriptions": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SizeSuggestionsApi.getProductSizeBanner": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SizeSuggestionsApi.getProductSizeSuggestion": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SizeSuggestionsApi.getSizingCycle": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SizeSuggestionsApi.getSizingModel": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SizeSuggestionsApi.getSizingOverview": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SizeSuggestionsApi.getWronglySizedProductsTab": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SizeSuggestionsApi.listSizingCycles": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "SizeSuggestionsApi.listSizingModels": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "StoreApi.calculateOrderPrice": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "StoreApi.fetchMenu": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "StoreApi.fetchProductDetails": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "StoreApi.fetchProducts": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "TicketClassifierApi.classifyFreeTextTicket": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
    "WfpApi.getQuote": [
        {
            url: "https://api.byrever.com",
            description: "Production server",
        },
        {
            url: "https://api.itsrever.com",
            description: "Production server (alternative name)",
        }
    ],
}
